import { ActiveUplink } from '../enums';

// Map Inhand's _active_link values to our ActiveUplink enum
// Use with ?? null to default to null for unmapped values
export const inhandActiveUplinkMap: Record<string, ActiveUplink> = {
  wan0: ActiveUplink.ETHERNET,
  wan1: ActiveUplink.CELLULAR,
  wan2: ActiveUplink.CELLULAR,
};
